import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const StyledRoot = styled.div({
  height: '100%',
  width: '100%',
  '& svg': {
    display: 'block',
    fill: 'currentColor',
    height: '100%',
    width: '100%',
  },
  '& img': {
    display: 'block',
    height: '100%',
    maxWidth: '100%',
  },
})

const Icon = ({ children }) => (
  <StyledRoot>{children}</StyledRoot>
)

Icon.propTypes = {
  children: PropTypes.element.isRequired,
}

Icon.displayName = 'Icon'

export default Icon
